import api from "./api";

const route = "/course_accesses";

const CourseAccessesService = {
  getCourseAccesses: () => api.get(route),
  putCourseAccess: (course_access) => api.put(route, course_access),
};
export default CourseAccessesService;
